var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCameraMuted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4636_681)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7013 15.4562C14.0578 15.0763 14.286 14.5941 14.3538 14.0775L18.2413 15.805C18.4315 15.8898 18.64 15.9257 18.8477 15.9094C19.0554 15.8931 19.2557 15.8252 19.4304 15.7118C19.6052 15.5984 19.7488 15.4431 19.8483 15.2601C19.9478 15.0771 19.9999 14.8721 20 14.6637V5.33625C19.9998 5.12809 19.9477 4.92328 19.8483 4.74039C19.7488 4.55751 19.6053 4.40234 19.4308 4.28898C19.2562 4.17561 19.0561 4.10764 18.8486 4.09123C18.641 4.07482 18.4327 4.11049 18.2425 4.195L14.3538 5.9225C14.2743 5.32136 13.9791 4.76958 13.5231 4.36991C13.0671 3.97024 12.4814 3.74993 11.875 3.75H5.34L13.7025 15.4562H13.7013ZM1.05875 4.20625C0.731527 4.43724 0.464566 4.74345 0.280322 5.0991C0.096079 5.45475 -5.75179e-05 5.84945 2.58174e-08 6.25V13.75C2.58174e-08 14.413 0.263392 15.0489 0.732233 15.5178C1.20107 15.9866 1.83696 16.25 2.5 16.25H9.66L1.05875 4.2075V4.20625ZM13.2413 19.1125L0.74125 1.6125L1.75875 0.887497L14.2587 18.3875L13.2413 19.1125Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4636_681"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraMuted);
export default __webpack_public_path__ + "static/media/cameraMuted.7aee167e6a938adef8248d8c66c732b7.svg";
export { ForwardRef as ReactComponent };